import React from 'react';
import { motion } from 'framer-motion';
import { FlameIcon } from 'lucide-react';
export function Problem() {
  return <section className="w-full bg-navy-900 px-4 py-20" data-id="element-128">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} className="max-w-4xl mx-auto text-center" data-id="element-129">
        <div className="flex justify-center mb-6" data-id="element-130">
          <div className="w-16 h-16 rounded-full bg-gold/10 flex items-center justify-center" data-id="element-131">
            <FlameIcon className="w-8 h-8 text-gold" data-id="element-132" />
          </div>
        </div>
        <h2 className="font-serif text-3xl md:text-4xl text-white mb-6" data-id="element-133">
          El Verdadero Problema
        </h2>
        <div className="h-1 w-24 bg-gold mx-auto mb-8" data-id="element-134"></div>
        <p className="text-gray-300 text-lg leading-relaxed mb-6" data-id="element-135">
          La ciencia moderna llama a esto insomnio por ansiedad, pero la
          Medicina China lo entiende mejor: tienes{' '}
          <span className="text-gold font-semibold" data-id="element-136">
            "Yang" atrapado en tu cabeza
          </span>
          . Tu energía está desequilibrada. No te falta sueño, te sobra calor
          energético en los órganos equivocados.
        </p>
        <p className="text-gray-300 text-lg leading-relaxed" data-id="element-137">
          Cuando intentas "forzar" el sueño, solo generas más frustración. Por
          eso la melatonina no funciona para ti; estás intentando apagar un
          incendio forestal con una gota de agua. Necesitas abrir las válvulas
          de presión físicas de tu cuerpo para que la energía descienda.
        </p>
      </motion.div>
    </section>;
}